<template>
  <div class="w-full" v-if="videos">
    <template v-if="isMobile">
      <app-slider
        class="mb-3"
        v-if="videos && isMobile"
        :items="videos"
        loop
        :thumbs="{ swiper: thumbsSwiper }"
        :slides-per-view="1"
      >
        <template #slide="item">
          <div class="aspect-w-16 aspect-h-9 w-screen max-w-full">
            <iframe
              title="youtubePlayer"
              id="ytplayer"
              allowfullscreen
              :src="geturl(item)"
            />
          </div>
        </template>
      </app-slider>
    </template>
    <template v-else>
      <div class="aspect-w-16 aspect-h-9 w-screen max-w-full mb-4">
        <iframe
          title="youtubePlayer"
          id="ytplayer"
          allowfullscreen
          :src="geturl(activeVideo)"
        />
      </div>
      <app-slider
        :items="videos"
        :slides-per-view="3"
        watch-slides-visibility
        watch-slides-progress
        loop
        slideToClickedSlide
        :space-between="16"
        class="md:block hidden"
      >
        <template #slide="item"
          ><img
            :alt="item.title"
            :src="item.image"
            @click="setVideo(item)"
            class="cursor-pointer"
        /></template>
      </app-slider>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    videos: Array
  },
  data: () => ({
    thumbsSwiper: null,
    activeVideo: undefined
  }),
  methods: {
    setVideo(video) {
      this.activeVideo = video;
    },
    geturl(video) {
      video = video || _.head(this.videos);
      return `https://www.youtube-nocookie.com/embed/${video?.id}?modestbranding=1&rel=0&showinfo=0&loop=0&color=white&iv_load_policy=3&autohide=1`;
    }
  }
};
</script>
